export class SelectionItem<idType = any> {
  constructor(public id: idType, public value: string, public disabled?: boolean) {}
}
